import {urlApp} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {Image} from 'react-native';
import {getUuid, widthScreen} from 'utils';
import {getStoreData} from 'utils/storage';
import md5 from 'md5';
export default function useAsyncState(t: any) {
  const [state, setState] = React.useState(t);
  const preState = useRef<any>(t);
  const funcCallback = useRef<any>(null);
  useEffect(() => {
    if (preState.current != state) {
      preState.current = state;
      if (funcCallback.current) {
        funcCallback.current(state);
      }
    }
  }, [state]);

  function handle(x: any, callback?: void) {
    setState(x);
    funcCallback.current = callback;
  }

  return [state, handle];
}

export function useImageUrl(t: string, method: 'GET' | 'POST', uri?: string) {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    getImage(t);
    return () => {};
  }, [t, uri]);

  const getImage = async (url: string) => {
    setLoading(true);
    const idNo = await getStoreData('idNo');
    const phone = await getStoreData('phone');
    const refCode = await getStoreData('refCode');
    const agentCode = await getStoreData('agentCode');
    const secretKey = await getStoreData('secretKey');
    const token = `${md5(`${idNo}${phone}${refCode}${agentCode}${secretKey}`)}`;
    try {
      // const token = await getStoreToken();
      const ul = `${urlApp.APIURL}api/${url}?Origin=${
        urlApp.DomainName
      }&token=${token || 'abc'}&uri=${uri || `${getUuid()}.png`}`;
      Image.getSize(
        ul,
        (width, height) => {
          setData({
            url: ul,
            width: widthScreen,
            height: (widthScreen / width) * height,
          });
        },
        failure => {},
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return [data, loading];
}
